import React, { useMemo } from "react";
import { Label } from "@jsq/ds/core";
import { FormTextInput, FormDatePicker } from "@jsq/ds/forms";
import { getAllEntityAccountTypes } from "../../utils/account_types";
import { isBeforeProvidedDate } from "../../utils/filter_date";
import { AccountTypeDropdown } from "../common/AccountTypeDropdown";
import { FieldGroup } from "../common/FieldGroup";
import { MultiInputFormRow } from "../common/MultiInputFormRow";
import { SimpleFormRow } from "../common/SimpleFormRow";
import { TaxIdInput } from "../TaxIdInput";
import { type BaseInputProps } from "./types";

export const EntityInformationInput: React.FC<BaseInputProps> = ({
  title = "Details",
  description,
  meta,
}: BaseInputProps) => {
  const entityTypes = useMemo(() => {
    return getAllEntityAccountTypes().map((type) => ({
      key: type.value,
      label: type.label,
    }));
  }, []);

  return (
    <FieldGroup title={title} description={description} meta={meta}>
      <SimpleFormRow>
        <FormTextInput
          key="legalBusinessName"
          data-testid="legalBusinessName"
          name="legalBusinessName"
          label="Legal business name"
          placeholder="Enter legal business name"
          isFullWidth
        />
      </SimpleFormRow>
      <SimpleFormRow>
        <AccountTypeDropdown
          key="entityType"
          name="entityType"
          accountTypes={entityTypes}
          placeholder="Entity type"
          label="Entity type"
        />
      </SimpleFormRow>
      <MultiInputFormRow>
        <>
          <Label htmlFor="dateOfFormation">Date of formation</Label>
          <FormDatePicker
            key="dateOfFormation"
            id="dateOfFormation"
            name="dateOfFormation"
            data-testid="dateOfFormation"
            isFull
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={125}
            maxDate={new Date()}
            placeholderText="MM/DD/YYYY"
            hasIcon
            data-cy="dateOfFormation"
            filterDate={isBeforeProvidedDate}
          />
        </>
        <TaxIdInput
          label="Identification number"
          description="Please provide a Taxpayer Identification Number (TIN). If your jurisdiction does not issue TINs (e.g., BVI, Cayman, Bermuda), enter your Company Registration Number or equivalent Official Identifier."
        />
      </MultiInputFormRow>
    </FieldGroup>
  );
};
